import React, { useEffect } from 'react';
import { SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_2_XS, SYS_SPACE_RELATIVE_4_XL, SYS_SPACE_RELATIVE_LG, } from '@oneaudi/unified-web-common';
import { useServicesContext } from '../../../../context';
import { Text } from '@oneaudi/unified-web-components';
import { DangerousElement } from '../../../../components';
import { isValidToRender } from './FinanceUtils';
import { readFinance, getValueFromPath, dynamicStylingHelper, DynamicComponent, } from '../../../utils';
import { useI18n } from '@oneaudi/i18n-context';
import styled from 'styled-components';
export const FinanceDisclaimerMessages = ({ financing, hideFinancingTable, hideCalculationDisclaimer, interpretDisclaimersTextStyle, position, disclaimerListItems, isPlp, vehicleId, vehicleType, }) => {
    const { getAdditionalService } = useServicesContext();
    const logger = getAdditionalService('s2:logger');
    const [financingInPDP, setFinancingInPDP] = React.useState(undefined);
    const disclaimerKey = useI18n({
        defaultMessage: '',
        id: 'stockcars.pricebreakdown.footnotes.headline',
    });
    useEffect(() => {
        var _a;
        if (!isPlp) {
            const result = readFinance(vehicleType);
            if (result) {
                const financeResponse = (_a = result === null || result === void 0 ? void 0 : result.financing[vehicleId]) === null || _a === void 0 ? void 0 : _a.financeResponseData;
                setFinancingInPDP(financeResponse);
            }
            else {
                logger === null || logger === void 0 ? void 0 : logger.error(`No financing data found for vehicleId: ${vehicleId}`);
            }
        }
    }, []);
    const DisclaimerWrapper = styled.div `
    a {
      color: white !important;
    }
  `;
    return (React.createElement(DisclaimerWrapper, null, disclaimerListItems &&
        disclaimerListItems.map((disclaimerListItem, index) => {
            const disclaimerName = disclaimerListItem.disclaimerMsgKey;
            const disclaimerMsg = isPlp
                ? financing[disclaimerName]
                : getValueFromPath(financingInPDP, disclaimerListItem.disclaimerMsgPath);
            if (disclaimerMsg &&
                position === disclaimerListItem.disclaimerPositionKey &&
                isValidToRender(disclaimerName, hideFinancingTable, hideCalculationDisclaimer)) {
                return (React.createElement(Text, { key: disclaimerName, tag: "p", variant: {
                        order: dynamicStylingHelper('2', position === 'Bottom' ? '3' : '1'),
                        style: 'normal',
                        type: 'copy',
                    }, margin: [
                        position === 'Bottom' && index === 1 ? SYS_SPACE_RELATIVE_4_XL : 0,
                        0,
                        position === 'Top'
                            ? dynamicStylingHelper(SYS_SPACE_FIXED_300, SYS_SPACE_RELATIVE_LG)
                            : 0,
                        0,
                    ] },
                    position === 'Bottom' && index === 1 && (React.createElement(DynamicComponent, { alpha: React.createElement(Text, { tag: "p", margin: [0, 0, SYS_SPACE_RELATIVE_2_XS, 0], variant: {
                                order: '3',
                                style: 'bold',
                                type: 'copy',
                            } }, disclaimerKey) })),
                    interpretDisclaimersTextStyle ? (React.createElement(DangerousElement, { as: "span", html: disclaimerMsg, sanitize: false })) : (disclaimerMsg === null || disclaimerMsg === void 0 ? void 0 : disclaimerMsg.replace(/<\/?[^>]+(>|$)/g, ''))));
            }
            return null;
        })));
};
